import React from 'react';
import '../pages/Interview.css';

/**
 * Quiet placeholder for a media region that is not live yet: sunken surface,
 * muted glyph + caption (no skeleton-screen dashes). Fills its container so
 * the region's geometry is stable and nothing jumps when real media swaps in.
 */
const MediaPlaceholder = ({ icon, caption, className = '' }) => (
    <div className={`media-placeholder${className ? ` ${className}` : ''}`}>
        {icon && <span className="media-placeholder-icon" aria-hidden="true">{icon}</span>}
        {caption && <p className="media-placeholder-caption">{caption}</p>}
    </div>
);

export default MediaPlaceholder;
